import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Button } from '@iterable/deprecated_react_components';
import { colors } from 'ui/theme';

type ConnectorType = {
  hideConnectorLines?: boolean;
  isOrConnector: boolean;
  isAndConnector: boolean;
  isNotConnector: boolean;
  isMainConnector?: boolean;
  isGroupConnector?: boolean;
  isTopConnector?: boolean;
  isLastConnector?: boolean;
  showLabel?: boolean;
};

export const getColors = (isAndConnector: boolean, isOrConnector: boolean) => {
  let backgroundColor = '#faeceb'; // isNotConnector
  let groupColor = '#d96458'; // isNotConnector
  let textColor = '#d14233'; // isNotConnector
  if (isOrConnector) {
    backgroundColor = '#eaf4fa';
    groupColor = '#54a2d7';
    textColor = '#2e8ece';
  } else if (isAndConnector) {
    backgroundColor = '#eaf9f0';
    groupColor = '#52ce86';
    textColor = '#2cc36b';
  }

  return { backgroundColor, groupColor, textColor };
};

export const AddGroupCoreButton = styled(Button)`
  &&&& {
    border-left: ${pxToRem(1)} solid #c3c3c5; /** css file replacement */
  }
`;

export const ButtonLabel = styled.span`
  margin-left: ${pxToRem(5)}; /** css file replacement */
`;

export const StyledCoreButtonGroup = styled(Button.Group)`
  &&&& {
    display: flex;
    position: relative;
    width: max-content;
    font-size: ${pxToRem(12)}; /** css file replacement */
    line-height: ${pxToRem(12)}; /** css file replacement */
    margin-bottom: ${pxToRem(10)}; /** css file replacement */
    .icon {
      margin: 0 !important;
    }
  }
`;

export const ConnectorLabelText = styled.span<ConnectorType>`
  ${({ isMainConnector, isTopConnector, isOrConnector, isAndConnector, showLabel }) => {
    const { groupColor } = getColors(isAndConnector, isOrConnector);
    if (!isMainConnector) return '';
    if (isTopConnector && showLabel) {
      return `
        width: auto;
        margin-top: calc(${pxToRem(48)} / 2);
      `;
    }
    return isTopConnector
      ? ''
      : `
        position: relative;
        background: ${groupColor};
        border-radius: ${pxToRem(5)};
        box-sizing: content-box;
        padding: ${pxToRem(3)};
        text-transform: uppercase;
        word-break: break-all;
        z-index: 10;
    `;
  }}
`;

export const ConnectorLabel = styled.div<ConnectorType>`
  align-items: center;
  border-radius: ${pxToRem(3)};
  display: flex;
  height: ${pxToRem(48)}; /** query builder connector size */
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  width: ${pxToRem(48)}; /** query builder connector size */
  z-index: 0;
  &:after {
    content: '';
    display: block;
    height: calc(100% - ${pxToRem(48)});
    left: calc(${pxToRem(48)} / 2);
    position: absolute;
    top: ${pxToRem(48)}; /** query builder connector size */
    width: ${pxToRem(1)};
  }
  ${({ isOrConnector, isAndConnector, isGroupConnector, isMainConnector, hideConnectorLines }) => {
    const { backgroundColor, groupColor, textColor } = getColors(isAndConnector, isOrConnector);
    const showGroupOrMainConnectorStyling = isGroupConnector || isMainConnector;
    return `
      background: ${showGroupOrMainConnectorStyling ? groupColor : backgroundColor};
      border: ${showGroupOrMainConnectorStyling ? 'none' : `${pxToRem(1)} solid ${groupColor}`};
      border-radius: ${showGroupOrMainConnectorStyling ? pxToRem(3) : 'none'};
      color: ${showGroupOrMainConnectorStyling ? colors.white : textColor};
      &:after {
        background: ${textColor};
      }
      [data-role='queryBuilder'][data-view-mode='true'] & {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      ${
        hideConnectorLines
          ? `
          height: 100%;
          &:before,
          &:after {
            content: '';
            display: none !important;
            height: 0;
            width: 0;
          }
      `
          : ``
      }
    `;
  }}
`;

export const GroupConnectorLabel = styled(ConnectorLabel)`
  margin-left: -${pxToRem(48)};
  :after {
    display: none;
  }
`;

export const MainConnectorLabel = styled(ConnectorLabel)`
  ${({ isOrConnector, isAndConnector, showLabel, isLastConnector }) => {
    const { groupColor } = getColors(isAndConnector, isOrConnector);
    return `
    ${
      showLabel
        ? `
            align-self: flex-end;
            margin-top: 0;
            z-index: 1;
          `
        : ''
    }
    > ${ConnectorLabelText} {
      display: ${isLastConnector ? 'none' : 'inherit'};
      [data-role='queryBuilder']:not([data-view-mode]) & {
        display: none;
      }
    }
    &:after {
      background: ${groupColor};
      height: 100%;
      width: ${pxToRem(2)};
    }
  `;
  }}
`;

export const MainTopConnectorLabel = styled(MainConnectorLabel)`
  [data-role='queryBuilder']:not([data-view-mode]) & {
    display: none;
  }
  height: calc(${pxToRem(48)} / 2);
  width: calc(${pxToRem(48)} * 2);
  margin: ${pxToRem(10)} ${pxToRem(10)} 0 0;
  &:after {
    top: ${pxToRem(20)};
  }
`;

export const MainNotTopConnectorLabel = styled(MainConnectorLabel)`
  align-self: self-end;
  background: none;
  margin-top: ${pxToRem(48)};
  height: auto;
  &:after {
    top: 0;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  position: relative;
  font-size: ${pxToRem(12)}; /** css file replacement */
  line-height: ${pxToRem(12)}; /** css file replacement */
`;
